var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$vuetify.theme.dark ? 'darkBackground' : 'lightBackground'
  }, [_c('div', {
    staticClass: "fill-width align-self-start"
  }, [_c('v-card', {
    staticClass: "d-flex align-center fill-width",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? '#22272e' : 'white',
      "flat": "",
      "height": "50",
      "tile": ""
    }
  }, [_c('a', {
    staticClass: "pa-5",
    attrs: {
      "href": "https://testapp.io"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$vuetify.theme.dark ? '/media/svg/logo-for-dark-theme.svg' : '/media/logos/logo_dark.svg',
      "alt": "TestApp.io",
      "height": "30"
    }
  })])])], 1), _c('v-container', [_vm.loading ? _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading, list-item-three-line, actions"
    }
  })], 1)], 1) : _vm.errorMessage ? _c('v-row', {
    staticClass: "mb-15",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "pa-10"
  }, [_c('v-col', {
    staticClass: "text-center titleFont bold-text",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" Oops! ")]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "red",
      "label": "",
      "outlined": ""
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  })])], 1), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('img', {
    staticClass: "mx-auto my-auto",
    attrs: {
      "src": "/media/error/not_available.png",
      "width": "260"
    }
  })])], 1)], 1)], 1) : _c('v-row', {
    staticClass: "mb-15",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "px-8 py-6",
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "100",
      "rounded": ""
    }
  }, [_vm.release.app.image ? _c('img', {
    attrs: {
      "src": _vm.release.app.image,
      "alt": _vm.release.app.name
    }
  }) : _c('v-icon', {
    attrs: {
      "size": "80"
    }
  }, [_vm._v("mdi-application")])], 1)], 1), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.release.app.name))]), _c('p', {
    staticClass: "text--secondary"
  }, [_vm._v(" Version " + _vm._s(_vm.release.info.version) + " ")])])], 1), _vm.release.user ? _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('user-avatar', {
    attrs: {
      "user-detail": _vm.release.user
    }
  }), _c('div', {
    staticClass: "ml-2 d-flex flex-column"
  }, [_c('span', {
    staticClass: "text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.release.user.name) + " ")]), _c('span', {
    staticClass: "text-caption text--secondary"
  }, [_c('vue-hoverable-date', {
    attrs: {
      "date": _vm.release.created_at
    }
  })], 1)])], 1)], 1) : _vm._e(), !_vm.isIOSSafari ? _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "warning",
      "outlined": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-alert")]), _c('div', [_vm._v(" We're opening your default browser. If it's not Safari, please copy this link and open it in Safari to install the app. ")])], 1)], 1), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('copy-link', {
    attrs: {
      "link": _vm.currentUrl
    }
  })], 1), _vm.isPotentiallyIPadDesktopMode ? _c('v-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v(" If you're using an iPad or iPhone, you may need to switch to mobile mode: ")]), _c('v-img', {
    attrs: {
      "width": "100%",
      "contain": "",
      "src": "/media/instruction/enable_mobile_mode.jpg",
      "alt": "Enable mobile mode in Safari"
    }
  }), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('a', {
    staticClass: "primary--text font-weight-bold",
    attrs: {
      "href": "https://help.testapp.io/faq/enable-mobile-mode-on-safari/",
      "target": "_blank"
    }
  }, [_vm._v(" Click here for more information ")])])], 1)], 1)], 1) : _vm._e()], 1) : _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "x-large": "",
      "block": "",
      "loading": _vm.installing
    },
    on: {
      "click": _vm.installApp
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v(" Install ")], 1)], 1)], 1), _vm.isIOSSafari && _vm.showInstructions ? _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "info",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v("Installation Started")]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" After installing, you'll find the app on your home screen. Return to TestApp.io to share your feedback! ")])])], 1)], 1) : _vm._e(), _vm.release.note ? _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "font-size-h2 mb-3 bold-text"
  }, [_vm._v("Release Notes")]), _c('div', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm.release.note.length > 600 ? _c('div', [_vm._v(" " + _vm._s(_vm.readMore ? _vm.release.note.substring(0, 600) : _vm.release.note) + " "), _c('span', {
    staticClass: "primary--text font-weight-bold",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.readMore = !_vm.readMore;
      }
    }
  }, [_vm._v(_vm._s(_vm.readMore ? "... Read More" : "Read Less"))])]) : _c('div', [_vm._v(" " + _vm._s(_vm.release.note) + " ")])])], 1)], 1) : _vm._e(), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider', {
    staticClass: "mb-4"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "text--secondary text-caption mb-1"
  }, [_vm._v("Version")]), _c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.release.info.version) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "text--secondary text-caption mb-1"
  }, [_vm._v("Size")]), _c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.formatBytes(_vm.release.info.size)) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "text--secondary text-caption mb-1"
  }, [_vm._v("Platform")]), _c('div', {
    staticClass: "font-weight-medium text-capitalize"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.release.platform === 'ios' ? 'grey' : 'green'
    },
    domProps: {
      "textContent": _vm._s(_vm.release.platform === 'android' ? 'mdi-android' : 'mdi-apple')
    }
  }), _vm._v(" " + _vm._s(_vm.release.platform) + " ")], 1)]), _vm.release.info.signing_type ? _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "text--secondary text-caption mb-1"
  }, [_vm._v(" Signing Type ")]), _c('div', {
    staticClass: "font-weight-medium text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.release.info.signing_type) + " ")])]) : _vm._e(), _vm.release.info.package ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8"
    }
  }, [_c('div', {
    staticClass: "text--secondary text-caption mb-1"
  }, [_vm._v("Package")]), _c('div', {
    staticClass: "font-weight-medium text-break"
  }, [_vm._v(" " + _vm._s(_vm.release.info.package) + " ")])]) : _vm._e()], 1), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "color": "info",
      "outlined": "",
      "dense": "",
      "icon": "mdi-shield-check"
    }
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_c('strong', [_vm._v("🔒 Secure Install Link")]), _c('br'), _vm._v(" This page is secure and not publicly shared. This link expires in 24 hours and can be regenerated from the TestApp.io mobile app if needed. ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }